import { gql } from '@apollo/client';

export const CREATE_MY_EXERCISE = gql`
  mutation createMyExercice($input: MyExerciceCreateInput!) {
    createMyExercice(input: $input) {
      _id
      user {
        _id
      }
      completed
      deleted
      exercice {
        _id
      }
      addedOn
    }
  }
`;

export const DISCARD_EXERCISE = gql`
  mutation discardExercice($id: String!, $action: discardType!) {
    discardExercice(id: $id, action: $action) {
      _id
    }
  }
`;

export const UNDISCARD_EXERCISE = gql`
  mutation unDiscardExercice($id: String!) {
    unDiscardExercice(id: $id) {
      _id
    }
  }
`;

export const ADD_DONE_EXERCISE = gql`
  mutation addDone($id: String!) {
    addDone(id: $id) {
      _id
    }
  }
`;

